import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion } from 'framer-motion';

const faqs = [
  {
    question: "Hvad er Keramisk Coating egentlig?",
    answer: "Keramisk coating er en flydende polymer, der påføres manuelt på bilens lak. Den danner en kemisk forbindelse med lakken og skaber et beskyttende lag, der er ekstremt hårdt, glat og modstandsdygtigt overfor ridser, UV-stråler og kemikalier."
  },
  {
    question: "Hvor længe holder en coating?",
    answer: "Vores standard coating holder i minimum 3 år ved korrekt vedligeholdelse. Vi tilbyder også løsninger, der holder helt op til 5 eller 9 år. Det er en markant bedre løsning end traditionel voks, som ofte kun holder få måneder."
  },
  {
    question: "Skal bilen poleres inden coating?",
    answer: "Ja, det er essentielt. For at coatingen kan hæfte optimalt og for at resultatet bliver perfekt, skal lakken være helt ren og fri for ridser. Derfor inkluderer alle vores pakker altid en form for polering og grundig klargøring."
  },
  {
    question: "Hvordan skal jeg vaske min bil efterfølgende?",
    answer: "Det bliver meget nemmere! Vi anbefaler en skånsom håndvask. Fordi overfladen er så glat, slipper snavset let, og du vil opleve, at vandet blot perler af (hydrofobisk effekt)."
  }
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-slate-500 font-bold tracking-widest uppercase text-sm mb-4">FAQ</h2>
          <h3 className="text-3xl md:text-4xl font-black text-slate-900 mb-4 uppercase">Ofte stillede spørgsmål</h3>
          <p className="text-slate-600 italic">Få svar på de mest almindelige spørgsmål om bilpleje og coating.</p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-4 lg:gap-8 items-start">
          {faqs.map((faq, index) => (
            <motion.div 
              key={index} 
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              className="border border-slate-200 rounded-3xl overflow-hidden transition-all bg-white shadow-xl shadow-slate-200/50"
            >
              <button 
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex justify-between items-center p-6 text-left hover:bg-slate-50 transition-colors group"
              >
                <span className="font-bold text-lg text-slate-900 pr-4">{faq.question}</span>
                <div className="shrink-0">
                  <ChevronDown 
                    className={`text-slate-900 transition-transform duration-300 ${
                      openIndex === index ? "rotate-180" : "text-slate-400"
                    }`} 
                  />
                </div>
              </button>
              
              <div 
                className={`grid transition-all duration-300 ease-in-out ${
                  openIndex === index 
                    ? "grid-rows-[1fr] opacity-100" 
                    : "grid-rows-[0fr] opacity-0"
                }`}
              >
                <div className="overflow-hidden">
                  <div className="p-6 pt-0 text-slate-600 leading-relaxed">
                    {faq.answer}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
